import styled from 'styled-components';

export const UploadRevisionStyled = styled.button(props => ({
  height: '26px',
  color: 'black',
  borderRadius: '40px',
  border: '1px solid black',
  paddingLeft: props.theme.spacing.medium,
  paddingRight: props.theme.spacing.medium,
  // fontSize: props.theme.font.size.xsmall,
  fontSize: '13px',
  transition: 'opacity 256ms ease-in-out',
  marginLeft: props.theme.spacing.xsmall,

  '&:hover': {
    opacity: 0.6,
  },
}));
